function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCod = function SvgCod(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8D47B"
    },
    d: "M18,38.5c-1.378,0-2.5-1.122-2.5-2.5v-8.5h5V36C20.5,37.378,19.378,38.5,18,38.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA9B48"
    },
    d: "M20,28v8c0,1.103-0.897,2-2,2s-2-0.897-2-2v-8H20 M21,27h-6v9c0,1.657,1.343,3,3,3s3-1.343,3-3V27 L21,27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8D47B"
    },
    d: "M23,37.5c-1.378,0-2.5-1.122-2.5-2.5v-8.5h5V35C25.5,36.378,24.378,37.5,23,37.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA9B48"
    },
    d: "M25,27v8c0,1.103-0.897,2-2,2s-2-0.897-2-2v-8H25 M26,26h-6v9c0,1.657,1.343,3,3,3s3-1.343,3-3V26 L26,26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#BA9B48"
    },
    cx: 12.5,
    cy: 27,
    rx: 3.5,
    ry: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8D47B"
    },
    d: "M28,35.5c-1.378,0-2.5-1.122-2.5-2.5V21.5h5V33C30.5,34.378,29.378,35.5,28,35.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA9B48"
    },
    d: "M30,22v11c0,1.103-0.897,2-2,2s-2-0.897-2-2V22H30 M31,21h-6v12c0,1.657,1.343,3,3,3s3-1.343,3-3 V21L31,21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.645,
    y: 9.638,
    transform: "matrix(0.4903 -0.8715 0.8715 0.4903 -2.1174 30.6625)",
    style: {
      fill: "#BAE0BD"
    },
    width: 27.024,
    height: 15.007
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E9C76"
    },
    d: "M25.436,2.363l12.202,6.877L24.878,31.92l-12.202-6.877L25.436,2.363 M25.056,1L11.315,25.424 l13.944,7.859L39,8.859L25.056,1L25.056,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAE0BD"
    },
    points: "11.442,28.201 20.107,2.633 34.366,7.43 25.701,32.998  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E9C76"
    },
    d: "M20.42,3.266l13.311,4.478l-8.344,24.621l-13.311-4.478L20.42,3.266 M19.793,2l-8.986,26.515 l15.207,5.116L35,7.116L19.793,2L19.793,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.905,23.314c-0.599,0-1.193-0.098-1.767-0.291c-1.4-0.471-2.53-1.457-3.184-2.776 c-0.65-1.313-0.75-2.801-0.279-4.189c0.758-2.237,2.859-3.741,5.228-3.741c0.599,0,1.193,0.098,1.767,0.291 c1.4,0.471,2.53,1.457,3.184,2.776c0.65,1.313,0.75,2.801,0.279,4.189C27.375,21.811,25.274,23.314,22.905,23.314z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E9C76"
    },
    d: "M22.904,12.817L22.904,12.817c0.544,0,1.085,0.089,1.607,0.265 c1.273,0.428,2.301,1.325,2.895,2.525c0.591,1.194,0.681,2.546,0.254,3.807c-0.689,2.034-2.6,3.401-4.755,3.401 c-0.545,0-1.085-0.089-1.607-0.265c-1.273-0.428-2.301-1.325-2.895-2.524c-0.591-1.194-0.681-2.546-0.254-3.807 C18.838,14.184,20.749,12.817,22.904,12.817 M22.903,11.817c-2.511,0-4.854,1.578-5.702,4.08c-1.063,3.138,0.628,6.541,3.777,7.6 c0.639,0.215,1.288,0.317,1.926,0.317c2.511,0,4.854-1.578,5.702-4.08c1.063-3.138-0.628-6.541-3.777-7.6 C24.191,11.919,23.542,11.817,22.903,11.817L22.903,11.817z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M26.113,9.845c-0.164,0-0.326-0.027-0.483-0.08c-0.382-0.128-0.69-0.397-0.868-0.757 c-0.177-0.358-0.205-0.764-0.076-1.142c0.207-0.611,0.78-1.021,1.426-1.021c0.164,0,0.326,0.027,0.483,0.08 c0.382,0.129,0.69,0.397,0.869,0.757c0.177,0.358,0.205,0.764,0.076,1.142C27.333,9.435,26.76,9.845,26.113,9.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E9C76"
    },
    d: "M26.113,7.346c0.109,0,0.218,0.018,0.323,0.053c0.255,0.086,0.461,0.265,0.58,0.505 c0.118,0.238,0.136,0.508,0.051,0.759c-0.138,0.407-0.521,0.681-0.954,0.681c-0.109,0-0.218-0.018-0.323-0.053 c-0.255-0.086-0.461-0.265-0.58-0.505c-0.118-0.238-0.136-0.508-0.051-0.759C25.297,7.62,25.681,7.346,26.113,7.346 M26.113,6.346 c-0.837,0-1.618,0.526-1.901,1.36c-0.354,1.046,0.209,2.18,1.259,2.533c0.213,0.072,0.429,0.106,0.642,0.106 c0.837,0,1.618-0.526,1.901-1.36c0.354-1.046-0.209-2.18-1.259-2.533C26.542,6.38,26.326,6.346,26.113,6.346L26.113,6.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEEA3"
    },
    d: "M1.5,38.5V23.262l9.237-6.413c0.292-0.232,0.625-0.349,0.964-0.349h3.663l-1.822,7.518l-2.264,2.688 c-0.254,0.302-0.31,0.708-0.146,1.06c0.166,0.357,0.521,0.588,0.905,0.588c0.164,0,0.323-0.041,0.474-0.121l8.015-5.253 c0.444-0.318,0.947-0.48,1.471-0.48c0.806,0,1.566,0.39,2.035,1.044c0.803,1.12,0.545,2.685-0.576,3.488L12.05,37.481 c-0.787,0.651-1.806,1.019-2.852,1.019H1.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA9B48"
    },
    d: "M14.729,17l-1.645,6.786l-2.188,2.598c-0.38,0.452-0.463,1.062-0.217,1.593 c0.248,0.533,0.781,0.877,1.359,0.877c0.243,0,0.488-0.062,0.708-0.179l0.041-0.022l0.039-0.025l8.009-5.254 C21.177,23.13,21.579,23,21.997,23c0.645,0,1.253,0.312,1.628,0.835c0.643,0.896,0.436,2.148-0.46,2.791l-0.049,0.035 l-0.044,0.041L11.75,37.08C11.034,37.673,10.128,38,9.198,38H2V23.523l9.022-6.263l0.028-0.019l0.027-0.021 C11.253,17.078,11.475,17,11.702,17H14.729 M16,16h-4.298c-0.454,0-0.895,0.155-1.249,0.438L1,23v16h8.198 c1.165,0,2.293-0.407,3.19-1.15l11.36-10.412c1.347-0.965,1.656-2.839,0.69-4.186C23.852,22.435,22.931,22,21.997,22 c-0.605,0-1.216,0.182-1.745,0.562l-7.975,5.23c-0.081,0.043-0.162,0.062-0.239,0.062c-0.385,0-0.673-0.475-0.378-0.826L14,24.25 L16,16L16,16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEEA3"
    },
    points: "3,22.829 1,24.217 1,38 3,38  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAE0BD"
    },
    d: "M15.05,16l-3.404,10.923l0.014,0.105c-0.354,0.421,0.131,1.021,0.617,0.764L15.01,26l1.809-10H15.05z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E9C76"
    },
    d: "M15.05,16l-3.504,11.245c0,0.001,0.003,0.005,0.003,0.006c-0.08,0.376,0.324,0.756,0.728,0.542 l0.183-0.12L16.097,16H15.05z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCod, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cod.e0c9286a.svg";
export { ForwardRef as ReactComponent };